var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_7083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0V0ZM4.0925 5.9075H13.6392C14.1191 5.91449 14.5771 6.10966 14.9145 6.451C15.252 6.79233 15.4419 7.25253 15.4433 7.7325V12.6183C15.4358 13.0972 15.2423 13.5544 14.9037 13.8931C14.5651 14.2319 14.108 14.4256 13.6292 14.4333H6.7C5.72167 14.4333 5 13.6083 5 12.6183V8.7525L3.7525 6.5875C3.49417 6.2375 3.71083 5.9075 4.0925 5.9075ZM6.93833 7.7325C6.64917 7.7325 6.37167 7.9075 6.37167 8.18583C6.37167 8.46417 6.64917 8.63917 6.93833 8.63917H13.5258C13.8142 8.63917 14.0925 8.46417 14.0925 8.18583C14.0925 7.9075 13.8142 7.73167 13.5258 7.73167L6.93833 7.7325ZM6.93833 9.54667C6.64917 9.54667 6.37167 9.72167 6.37167 10C6.37167 10.2783 6.64917 10.4533 6.93833 10.4533H13.5258C13.8142 10.4533 14.0925 10.2783 14.0925 10C14.0925 9.72167 13.8142 9.54667 13.5258 9.54667H6.93833ZM6.9275 11.3717C6.63917 11.3717 6.36083 11.5467 6.36083 11.825C6.36083 12.1033 6.63917 12.2783 6.9275 12.2783H11.7008C11.99 12.2783 12.2675 12.1033 12.2675 11.825C12.2675 11.5467 11.99 11.3708 11.7008 11.3708L6.9275 11.3717Z",
    fill: "#3350B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_7083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.656b02380f730da844c3a379163b0ba3.svg";
export { ForwardRef as ReactComponent };